const escapeCsv = value => {
  const text = String(value ?? '');
  if (/[",\n;]/.test(text)) return `"${text.replace(/"/g, '""')}"`;
  return text;
};

export const buildCsv = (headers, rows) =>
  [headers, ...rows].map(row => row.map(escapeCsv).join(',')).join('\n');

export const csvHeadersFor = (locale, english, spanish) =>
  String(locale || '')
    .toLowerCase()
    .startsWith('es')
    ? spanish
    : english;

export const downloadCsv = (filename, content) => {
  const blob = new Blob([`\uFEFF${content}`], {
    type: 'text/csv;charset=utf-8',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.click();
  URL.revokeObjectURL(url);
};
